import { messages } from './messages';
import { attributes } from './attributes';
var locale = {
  name: 'tr',
  messages: messages,
  attributes: attributes
};
export default locale;